module.exports = __webpack_public_path__ + "static/media/Deli_Check.97b98b8e.svg";